import { Node } from '../../Node';
/**
 * @category Flow shape
 */
export class BroadcastNode extends Node {}